
import { useEffect, useState } from "react";

import { connect } from "react-redux";


import UiSearchDropDown from "../../../components/inputs/UiSearchDropDown";
import { updateStorageInventoriesArr } from "../../../utilities/storage";
import { UiIngredientListItem } from "./ingredient-list-item";


import {
  getInventoriesList as getInventoriesListAction,
  addStorage as addStorageAction,
  updateInventories as updateInventoriesAction,
} from "../../../redux/modules/storage";
import UiInputText from "../../../components/inputs/UiInputText";
import UiButtonColor from "../../../components/button/UiButtonColor";


const UiIngredientList = (props) => {

  const [storageList, setStorageList] = useState([]);

  const [storageId, setStorage] = useState(0);
  const [count, setCount] = useState(1);

  const list = [{}];

  useEffect(() => {
    props.getInventoriesList().then((data) => {
      if (data) setStorageList(data.data);

    });

  }, []);

  const convertToList = (list) => {


    return list.map((item) => { return { label: item.title + " " + item.price + " р", value: (item.id || 0).toString() } })
  }

  var ingredientList = props.inventories.filter((it) => it.is_del != 1).map((item, index) => {
    return (
     <div key={index} style={{display: 'flex', alignItems: 'left'}}>
      <span >№{index + 1} {item.title} - {item.count} шт.</span>
      <button 
        onClick={() => {
          props.onChange([
            ...props.inventories.filter((it) => it.id != item.id),
            { ...item, is_del: 1 }
          ]);
        }}
        style={{marginLeft: '10px', padding: '4px 8px', cursor: 'pointer'}}
      >
       ❌ Удалить
      </button>
    </div>
    );
  });

  return (
    <div className="product-add-info-form">
      <div className="added-list">


        <div className="added-list-items">
          {ingredientList}
        </div>

        <UiSearchDropDown
          label="Цветок для состава"
          value={null}
          showEmptyVal
          items={convertToList(storageList)}
          onChange={(val) => {
            console.log(val)
            setStorage(val)
          }}
        />

        <UiInputText
          label="Количество"
          size="sm"
          type="number"

          value={count.toString()}
          onChange={(v) => {
            if (parseInt(v) > 0 && parseInt(v) <= 9999) setCount(parseInt(v))
          }}

        />
      </div>

      <UiButtonColor
        color="primary"
        text="Добавить"

        disabled={storageId == null}
        onClick={() => {
          if (storageId) {

            let arr = updateStorageInventoriesArr({
              title: storageList.find((it) => it.id == storageId)?.title,
              storage_id: props.id,
              inventory_id: storageId,
              count: count,
              price: storageList.find((it) => it.id == storageId)?.price || 0,
            }, props.inventories);

            console.log(arr)

            props.onChange(arr)
            setStorage(undefined);
            setCount(1);
          }

        }}
      />




    </div>
  );
};


export default connect(
  ({ storage, login }) => ({
    storage,
    login,
  }),
  {
    getInventoriesList: getInventoriesListAction,
  }
)(UiIngredientList);